'use strict';

var ImmobiliareFlux = require('./module');

module.exports = {
    SimpleText: ImmobiliareFlux.createComponent({
        /**
         * @returns {string}
         */
        get: function () {
            return this.$el.text();
        },
        /**
         * @param {string} value
         */
        set: function (value) {
            if (this.get() !== value) {
                this.$el.text(value);
            }
        }
    }),
    Input: ImmobiliareFlux.createComponent({
        /**
         * @returns {string}
         */
        get: function () {
            return this.$el.val();
        },
        /**
         * @param {string} value
         */
        set: function (value) {
            if (this.get() !== value) {
                this.$el
                    .val(value)
                    .trigger('change');
            }
        }
    }),
    Checkbox: ImmobiliareFlux.createComponent({
        /**
         * @returns {boolean}
         */
        get: function () {
            return this.$el.is(':checked');
        },
        /**
         * @param {boolean} value
         */
        set: function (value) {
            if (this.get() !== value) {
                this.$el
                    .prop('checked', !!value)
                    .trigger('change');
            }
        }
    }),
    Radio: ImmobiliareFlux.createComponent({
        get: function () {
            var value;

            this.getRadioElements().each(function () {
                if ($(this).is(':checked')) {
                    value = $(this).val();

                    return false; //break
                }
            });

            return value;
        },
        set: function (value) {
            if (String(this.get()) !== String(value)) {
                this.getRadioElements().each(function () {
                    if (String($(this).val()) === String(value)) {
                        $(this).prop('checked', true)
                            .trigger('change');

                        return false; //break
                    } else {
                        $(this).prop('checked', false);
                    }
                });
            }
        },
        getRadioElements: function () {

            if (typeof this.$radioElements === 'undefined') {
                this.$radioElements = this.$el.find('input[type=radio]');
            }

            return this.$radioElements;
        }
    })
};
